<template>
  <a-modal
    :title="title"
    :width="width"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭">
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">

        <a-form-item label="文件id" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'busId', validatorRules.busId]" placeholder="请输入文件id"></a-input>
        </a-form-item>
        <a-form-item label="文件名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'busName', validatorRules.busName]" placeholder="请输入文件名称"></a-input>
        </a-form-item>
        <a-form-item label="操作类型code(10：上传，20：编辑，30：删除)" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'logStatusCode', validatorRules.logStatusCode]" placeholder="请输入操作类型code(10：上传，20：编辑，30：删除)"></a-input>
        </a-form-item>
        <a-form-item label="操作类型(编码对应中文)" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'logStatusTxt', validatorRules.logStatusTxt]" placeholder="请输入操作类型(编码对应中文)"></a-input>
        </a-form-item>
        <a-form-item label="业务表类型(10:文件，20：文件分类)" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'busType', validatorRules.busType]" placeholder="请输入业务表类型(10:文件，20：文件分类)"></a-input>
        </a-form-item>
        <a-form-item label="创建人" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'createBy', validatorRules.createBy]" placeholder="请输入创建人"></a-input>
        </a-form-item>
        <a-form-item label="创建时间" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-date placeholder="请选择创建时间" v-decorator="[ 'createTime', validatorRules.createTime]" :trigger-change="true" style="width: 100%"/>
        </a-form-item>
        <a-form-item label="修改人" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'updateBy', validatorRules.updateBy]" placeholder="请输入修改人"></a-input>
        </a-form-item>
        <a-form-item label="修改时间" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-date placeholder="请选择修改时间" v-decorator="[ 'updateTime', validatorRules.updateTime]" :trigger-change="true" style="width: 100%"/>
        </a-form-item>
        <a-form-item label="sysOrgCode" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'sysOrgCode', validatorRules.sysOrgCode]" placeholder="请输入sysOrgCode"></a-input>
        </a-form-item>
        <a-form-item label="备注" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'remark', validatorRules.remark]" placeholder="请输入备注"></a-input>
        </a-form-item>

      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>

  import { httpAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import { validateDuplicateValue } from '@/utils/util'
  import JDate from '@/components/jeecg/JDate'  

  export default {
    name: "BusCommonFileLogModal",
    components: { 
      JDate,
    },
    data () {
      return {
        form: this.$form.createForm(this),
        title:"操作",
        width:800,
        visible: false,
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
          busId: {rules: [
          ]},
          busName: {rules: [
          ]},
          logStatusCode: {rules: [
          ]},
          logStatusTxt: {rules: [
          ]},
          busType: {rules: [
          ]},
          createBy: {rules: [
          ]},
          createTime: {rules: [
          ]},
          updateBy: {rules: [
          ]},
          updateTime: {rules: [
          ]},
          sysOrgCode: {rules: [
          ]},
          remark: {rules: [
          ]},
        },
        url: {
          add: "/factory/base/busCommonFileLog/add",
          edit: "/factory/base/busCommonFileLog/edit",
        }
      }
    },
    created () {
    },
    methods: {
      add () {
        this.edit({});
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'busId','busName','logStatusCode','logStatusTxt','busType','createBy','createTime','updateBy','updateTime','sysOrgCode','remark'))
        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'post';
            }
            let formData = Object.assign(this.model, values);
            console.log("表单提交数据",formData)
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
              that.close();
            })
          }
         
        })
      },
      handleCancel () {
        this.close()
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'busId','busName','logStatusCode','logStatusTxt','busType','createBy','createTime','updateBy','updateTime','sysOrgCode','remark'))
      },

      
    }
  }
</script>